import { useEffect, useState } from "react";
import useAxios from "@hooks/use-axios";
import useSearchParams from "@hooks/use-search-params";
import { decoColumns } from "./misc/deco-columns";
import { useParams } from "react-router-dom";

const useCustomFields = () => {
    const { axiosInstance, loading, cancelAllRequests } = useAxios({ base: "panel", initialLoader: true });
    const [data, setData] = useState({ fields: [], pagination: {} });
    const [queryParams, setQueryParams] = useState({});
    const { getSearchParams } = useSearchParams();
    const [modalConfig, setModalConfig] = useState({ isOpen: false, row: {} });
    const { platformId } = useParams();      

    const handleModalConfig = (row = {}) => {
        setModalConfig(prev => ({ row, isOpen: !prev.isOpen }));
    };

    const getCustomAttributes = async () => {
        const { data, pagination } = await axiosInstance.get(`/field/${platformId}/client`, {
            params: {
                page : getSearchParams("page"),
                limit: getSearchParams("limit")
            }
        });

        setData({
            fields    : data || [],
            pagination: pagination || {}
        });
    };

    const handleRowActions = async (row, action) => {
        if (action === "delete") {
            await axiosInstance.delete(`/field/${platformId}/${row._id}`);
            getCustomAttributes();
            return;
        }
        handleModalConfig(row);
    };

    useEffect(() => {
        let isActive = true;
        if (isActive) getCustomAttributes();
        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [queryParams]);

    return {
        data,
        loading,
        columns: decoColumns({ handleRowActions }),
        setQueryParams,
        handleModalConfig,
        modalConfig,
        getCustomAttributes
    };
};

export default useCustomFields;
